import { Box, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import ReusableDialog from "../../../common/dialog/dialog";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";

const ItemsRemoved = ({ items, setItems }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newItemName, setNewItemName] = useState("");
  const [newItemCount, setNewItemCount] = useState(0);

  const handleIncrement = (index) => {
    const updatedItems = [...items];
    updatedItems[index].count++;
    setItems(updatedItems);
  };

  const handleDecrement = (index) => {
    const updatedItems = [...items];
    if (updatedItems[index].count > 0) updatedItems[index].count--;
    setItems(updatedItems);
  };

  const handleDelete = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setNewItemName("");
    setNewItemCount(0);
  };

  const handleAddNewItem = () => {
    if (newItemName.trim() && newItemCount >= 0) {
      setItems([...items, { name: newItemName, count: newItemCount }]);
      handleDialogClose();
    }
  };

  const handleCountChange = (e, index) => {
    const newValue = e.target.value;

    // Ensure the value is a valid number
    if (!isNaN(newValue) || newValue === "") {
      const updatedItems = [...items];
      updatedItems[index].count = newValue; // Update the specific item's count
      setItems(updatedItems); // Update state
    }
  };
  return (
    <Box>
      <Grid container spacing={3} sx={{ mb: 2 }}>
        <Grid item lg={9}>
          <Typography sx={{ fontSize: "14px" }}>Items removed & how stored or disposed of</Typography>
        </Grid>
        <Grid item lg={3}>
          <Button variant='contained' onClick={handleDialogOpen}>
            Add Item
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {items.map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #ECECED",
                borderRadius: "8px",
                p: 1,
              }}
            >
              <Typography>{item.name}</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.1 }}>
                <IconButton color='primary' size='small' onClick={() => handleDecrement(index)}>
                  <RemoveIcon />
                </IconButton>
                <TextField
                  value={item.count}
                  size='small'
                  onChange={(e) => handleCountChange(e, index)} // Add onChange event
                  inputProps={{
                    style: { textAlign: "center", width: "40px" },
                  }}
                />

                <IconButton color='primary' size='small' onClick={() => handleIncrement(index)}>
                  <AddIcon />
                </IconButton>

                <IconButton color='primary' size='small' onClick={() => handleDelete(index)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <ReusableDialog
        isOpen={dialogOpen}
        onClose={handleDialogClose}
        title='Add A Item'
        onSubmit={handleAddNewItem}
        submitText='Submit'
        cancelText='Cancel'
      >
        <Typography sx={{ fontSize: "14px", color: "black" }}>Item Name</Typography>
        <TextField
          name='itemName'
          fullWidth
          variant='outlined'
          value={newItemName}
          onChange={(e) => setNewItemName(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Typography sx={{ fontSize: "14px", color: "black", mb: 1 }}>Quantity Available </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <TextField
            name='itemCount'
            value={newItemCount}
            size='small'
            type='number'
            inputProps={{ style: { textAlign: "center", width: "60px" } }}
            onChange={(e) => setNewItemCount(Number(e.target.value))}
          />
          <IconButton color='primary' onClick={() => setNewItemCount((prev) => Math.max(prev - 1, 0))}>
            <RemoveIcon />
          </IconButton>
          <IconButton color='primary' onClick={() => setNewItemCount((prev) => prev + 1)}>
            <AddIcon />
          </IconButton>
        </Box>
      </ReusableDialog>
    </Box>
  );
};

export default ItemsRemoved;
